export const TITLE = {
  "/ncov": "疫情AI分析",
  "/industrydb": "智客",
  "/": "智数",
}
